import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components'
import { groupHomeConstants as gh } from 'srcReact/GroupHomePage'
import { redirectToPage } from 'srcReact/helpers/history'
import { isNative } from 'srcReact/helpers/utils'
import { groupHomeService, generalService, groupService } from 'srcReact/services'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const groupHomeActions = {
  resetAction,
  getGroupHomeGroupInfo,
  getGroupWidgetScope,
  getGroupHomeMixrFutureList,
  getGroupHomeMixrFutureListPagination,
  getGroupHomeMixrPastList,
  getGroupHomeMixrPastListPagination,
  getGroupHomeInfo,
  getGroupHomeGroupMedia,
  getGroupPendingActions,
  memberPendingApproveGroup,
  memberPendingRejectGroup,
  suggestedAcceptMixrGroup,
  suggestedRejectMixrGroup,
  addMemberToGroup,
  removeMemberFromGroup,
  deleteGroup,
  getParticipants,
  deleteFileFromGroup,
  addStaffRole,
  removeStaffRole,
  removeFromGroup,
  setGroupRole,
  acceptInvitation,
  declineInvitation,
  getUsersToInvite,
  setInitialState,
  updateRSVPData
}

function resetAction(type) {
  return { type: gh[`RESET_${type}`] }
}

function setInitialState() {
  return { type: gh.SET_INITIAL_STATE }
}
function setGroupRole(joinedGroup) {
  return { type: gh.SET_GROUP_ROLE, joinedGroup: joinedGroup }
}

function getGroupHomeGroupInfo(groupId, scope = `stats`, widgetScope = 'feed') {
  return (dispatch) => {
    dispatch(request({ groupId, scope }))

    groupHomeService.getGroupInfo(groupId, scope, widgetScope).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_GROUP_INFO_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_GROUP_INFO_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_GROUP_INFO_FAILURE, error }
  }
}

function getGroupHomeGroupMedia(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupHomeService.getGroupInfo(groupId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_MEDIA_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_MEDIA_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_MEDIA_FAILURE, error }
  }
}

function getGroupHomeMixrFutureList(groupId, scope = 'future_mixrs', offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ groupId, scope, offset, quantity }))

    groupHomeService.getGroupScope(groupId, scope, offset, quantity).then(
      (response) => {
        response.future_mixrs.mixrs.map((m) => Object.assign(m, { mixr_over: false, pagination: offset }))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_FAILURE, error }
  }
}

function getGroupHomeMixrFutureListPagination(
  groupId,
  scope = 'future_mixrs',
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ groupId, scope, offset, quantity }))

    groupHomeService.getGroupScope(groupId, scope, offset, quantity).then(
      (response) => {
        response.future_mixrs.mixrs.map((m) => Object.assign(m, { mixr_over: false, pagination: offset }))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE, error }
  }
}

function getGroupHomeMixrPastList(groupId, scope = 'past_mixrs', offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ groupId, scope, offset, quantity }))

    groupHomeService.getGroupScope(groupId, scope, offset, quantity).then(
      (response) => {
        response.past_mixrs.mixrs.map((m) => Object.assign(m, { mixr_over: true, pagination: offset }))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_FAILURE, error }
  }
}

function getGroupHomeMixrPastListPagination(groupId, scope = 'past_mixrs', offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ groupId, scope, offset, quantity }))

    groupHomeService.getGroupScope(groupId, scope, offset, quantity).then(
      (response) => {
        response.past_mixrs.mixrs.map((m) => Object.assign(m, { mixr_over: true, pagination: offset }))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_FAILURE, error }
  }
}

function getGroupHomeInfo(groupId, scope = `stats,staff_members`) {
  return (dispatch) => {
    dispatch(request({ groupId, scope }))

    groupHomeService.getGroupScope(groupId, scope).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_INFO_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_INFO_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_INFO_FAILURE, error }
  }
}

function getGroupPendingActions(groupId, scope = `pending_members,suggested_mixrs`) {
  return (dispatch) => {
    dispatch(request({ groupId, scope }))

    groupHomeService.getGroupScope(groupId, scope).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GET_GROUPHOME_PENDING_ACTIONS_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GET_GROUPHOME_PENDING_ACTIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GET_GROUPHOME_PENDING_ACTIONS_FAILURE, error }
  }
}

function suggestedAcceptMixrGroup(mixrId, attending) {
  return (dispatch) => {
    dispatch(request({ mixrId, attending }))

    groupHomeService.suggestedAcceptMixr(mixrId, attending).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_FAILURE, error }
  }
}

function suggestedRejectMixrGroup(mixrId) {
  return (dispatch) => {
    dispatch(request({ mixrId }))

    groupHomeService.suggestedRejectMixr(mixrId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_FAILURE, error }
  }
}

function memberPendingApproveGroup(groupId, userId) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.memberPendingApprove(groupId, userId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_FAILURE, error }
  }
}

function memberPendingRejectGroup(groupId, userId) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.memberPendingReject(groupId, userId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_REQUEST, data }
  }
  function success(data) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.GROUPHOME_PENDING_ACTIONS_FAILURE, error }
  }
}

function removeMemberFromGroup(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupHomeService.removeMemberFromGroup(groupId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.LEAVE_GROUP_MEMBER_REQUEST, data }
  }
  function success(data) {
    return { type: gh.LEAVE_GROUP_MEMBER_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.LEAVE_GROUP_MEMBER_FAILED, error }
  }
}

function addMemberToGroup(groupId, redirectUrl) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupService.joinGroup(groupId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
        if (redirectUrl) {
          redirectToPage(redirectUrl, isNative(), true)
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.JOIN_GROUP_MEMBER_REQUEST, data }
  }
  function success(data) {
    return { type: gh.JOIN_GROUP_MEMBER_SUCCESS, data, groupId: groupId }
  }
  function failure(error) {
    return { type: gh.JOIN_GROUP_MEMBER_FAILED, error }
  }
}

function deleteGroup(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupHomeService.deleteGroup(groupId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: gh.DELETE_GROUP_REQUEST, data }
  }
  function success(data) {
    return { type: gh.DELETE_GROUP_SUCCESS, data }
  }
  function failure(error) {
    return { type: gh.DELETE_GROUP_FAILURE, error }
  }
}

function updateRSVPData(mixrId, rsvpData, pagination) {
  return { type: gh.UPDATE_RSVP_DATA, mixrId, rsvpData, pagination }
}

function getParticipants(id, scope, pagination, search, order, quantity = PAGINATION_QUANTITY) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))

    groupHomeService.getParticipants(id, scope, nextOffset, quantity, search, order).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(isPagination) {
    if (scope === 'active_members') {
      return { type: gh.GET_PARTICIPANTS_REQUEST, isPagination }
    } else {
      return { type: gh.GET_ORGANIZERS_REQUEST, isPagination }
    }
  }
  function success(response) {
    const updatedResponse = { ...response, isPagination, search }
    if (scope === 'active_members') {
      return { type: gh.GET_PARTICIPANTS_SUCCESS, updatedResponse }
    } else {
      return { type: gh.GET_ORGANIZERS_SUCCESS, updatedResponse }
    }
  }
  function failure(error) {
    if (scope === 'active_members') {
      return { type: gh.GET_PARTICIPANTS_FAILURE, error }
    } else {
      return { type: gh.GET_PARTICIPANTS_FAILURE, error }
    }
  }
}

function deleteFileFromGroup(groupId, fileId) {
  return (dispatch) => {
    dispatch(request({ groupId, fileId }))

    groupHomeService.deleteFileFromGroup(groupId, fileId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.DELETE_FILE_REQUEST, response }
  }
  function success(response) {
    return { type: gh.DELETE_FILE_SUCCESS, response }
  }
  function failure(error) {
    return { type: gh.DELETE_FILE_FAILURE, error }
  }
}

function addStaffRole(groupId, userId, role) {
  return (dispatch) => {
    dispatch(request({ groupId, userId, role }))

    groupHomeService.addStaffRole(groupId, userId, role).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.ADD_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: gh.ADD_STAFF_ROLE_SUCCESS, response, actionType: 'add' }
  }
  function failure(error) {
    return { type: gh.ADD_STAFF_ROLE_FAILURE, error }
  }
}

function removeStaffRole(groupId, userId, scope) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.removeStaffRole(groupId, userId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.REMOVE_STAFF_ROLE_REQUEST, response }
  }
  function success(response) {
    return { type: gh.REMOVE_STAFF_ROLE_SUCCESS, response, scope, actionType: 'remove' }
  }
  function failure(error) {
    return { type: gh.REMOVE_STAFF_ROLE_FAILURE, error }
  }
}

function removeFromGroup(groupId, userId) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.removeFromGroup(groupId, userId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.REMOVE_FROM_GROUP_REQUEST, response }
  }
  function success(response) {
    return { type: gh.REMOVE_FROM_GROUP_SUCCESS, response }
  }
  function failure(error) {
    return { type: gh.REMOVE_FROM_GROUP_FAILURE, error }
  }
}

function acceptInvitation(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupService.acceptInvitation(groupId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.ACCEPT_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: gh.ACCEPT_INVITATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: gh.ACCEPT_INVITATION_FAILURE, error }
  }
}

function declineInvitation(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupService.declineInvitation(groupId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.DECLINE_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: gh.DECLINE_INVITATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: gh.DECLINE_INVITATION_FAILURE, error }
  }
}

function getUsersToInvite(groupId, search, order, pagination, quantity = appConstantSettings.PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupHomeService
      .getUsersToInvite(groupId, 'suggested_members', pagination.nextOffset, quantity, search, order)
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: gh.GET_USERS_TO_INVITE_REQUEST, response, pagination }
  }
  function success(response) {
    return { type: gh.GET_USERS_TO_INVITE_SUCCESS, response, pagination, search }
  }
  function failure(error) {
    return { type: gh.GET_USERS_TO_INVITE_FAILURE, error }
  }
}

function getGroupWidgetScope(groupId, widgetScope) {
  return (dispatch) => {
    dispatch(request({ groupId, widgetScope }))

    groupHomeService.getGroupWidgetScope(groupId, widgetScope).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: gh.GET_WIDGET_SCOPE_REQUEST, response }
  }
  function success(response) {
    return { type: gh.GET_WIDGET_SCOPE_SUCCESS, response }
  }
  function failure(error) {
    return { type: gh.GET_WIDGET_SCOPE_FAILURE, error }
  }
}
